export default "__VITE_ASSET__D$9ezQmM__"